var _ = require('lodash');
var angular = require('angular/index');
require('../core');

angular
  .module('utility-ng-interface')
  .factory('ObjectListBuilder', function ObjectListBuilderDefinition(ArrayListBuilder) {
    return function ObjectListBuilder(list, builder) {
      return _.zipObject(_.keys(list), ArrayListBuilder(list, builder));
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-interface/src/adt/object_list_builder.js